<template>
  <div class="gird">
    <!-- <van-grid :column-num="5" channel.length>
      <van-grid-item
        v-for="item in channel"
        :key="item.id"
        :icon="item.imgUrl"
        :text="item.text"
        @click="btn(item.id)"
      />
    </van-grid> -->
    <div>
      <div  style="display: flex;justify-content: space-evenly;text-align: center;">
        <div v-for="item in channel" :key="item.id" style="line-height: 20px;">
          <img style="width:46px;height: 46px;" :src="item.imgUrl" alt="" srcset="">
          <p style="font-size:14px;">{{item.text}}</p>
        </div>
      </div>
    </div>
    <div>
      <div style="display: flex;overflow: auto;white-space: nowrap;width: 100%;">
        <!-- <div style="margin: 5.5px;text-align:center;" v-for="item in categoryinfoList" :key="item.id"> -->
        <div style="width: 19.5%;display: inline-block;" v-for="item in categoryinfoList" :key="item.id" :class="item.categoryId == 284 ?'a':'b'">
          <img style="height: 46px;"  :src="item.icon" alt="">
          <p style="font-size: 14px;">{{item.categoryName}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "gird",
  props: ["channel",'categoryinfoList'],
  methods: {
    btn(id){
      this.$router.push({path: '/channel', query:{id: id}})
    }
  }
};
</script>

<style>
.gird{
  margin: 10px;
    background-color: azure;
    border-radius: 12px;
}
/* .a{
  margin-left: 15px;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-right: 8px;
} */
/* .b{
  margin-top: 10px;
  margin-left: 7px;
  margin-right: 7px;
} */
</style>